import { ApiService } from '../apiService'
import { SmtpDiagnostics, EmailTestRequest, EmailTestResponse } from '../types/email'

export const emailApi = {
  // Effective SMTP configuration (no secrets) so admins can confirm what's in force.
  getEmailTestConfig: () =>
    ApiService.get<SmtpDiagnostics>('/admin/email-test/config'),

  // Sends a test email synchronously and reports success or the exact SMTP error.
  sendEmailTest: (data: EmailTestRequest) =>
    ApiService.post<EmailTestResponse>('/admin/email-test', data),
}
